<template>
  <div class="d-flex align-items-center">
    <div class="report__property-icon-container">
      <slot name="icon"></slot>
    </div>
    <p class="report__property-icon-item-label">{{ label }}</p>
  </div>
</template>
<script>
export default {
  props: {
    label: [String, Number],
  },
};
</script>

<style>
.report__property-icon-item-label {
  color: #666666;
  margin-bottom: 0px;
  margin-top: 4px;
  font-size: 12px;
  font-weight: 700;
}
.report__property-icon-container {
  height: 16px;
  width: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
  font-family: "DM Sans";
}
</style>
